<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="产品类型"
      edit-title
      id-key="Id"
      :data="data"
      :line-form="true"
      form-label-width="90px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="类型名称" prop="TypeName">
              <el-input v-model="data.TypeName" placeholder="请输入类型名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型编码" prop="TypeCode">
              <el-input v-model="data.TypeCode" placeholder="请输入类型编码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="12">
          <el-form-item label="序号" prop="Sn">
            <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
            <span class="t-tips">*值越小排得越前</span>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select v-model="data.Status">
                <el-option :value="1" label="启用"></el-option>
                <el-option :value="0" label="禁用"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Id: 0,
        TypeName: "",
        TypeCode: "",
        Sn: 0,
        Status: 1
      },
      api: require('@/api/ba/equipmentFailure').default,
      rules: {
        TypeName: [{ required: true, message: '请输入类型名称' }],
        TypeCode: [{ required: true, message: '请输入类型编码' }],
        Sn: [{ required: true, message: '请输入序号' }],
      },
    }
  },
  methods: {
    onCreateOpened() {},
    onEditOpened(data) {
      
    },
    onBeforeSave() {
    
    },
  }
}
</script>
